const ProductOrderStatusEnum = {
  DELIVERED: 1,
  WAIT_FOR_PAY: 2,
  CANCEL: 3,
  PREPARE: 4,
  PAID_ONLINE: 6
}
export default ProductOrderStatusEnum
